module.exports = __webpack_public_path__ + "img/gs1_logo.b69b4a36.png";